import { Skeleton } from '@carvana/helios-decoration';

import { CardWrapper, SkeletonImageWrap } from './SummaryTile.styles';

export const SummaryTileSkeleton = () => (
  <CardWrapper
    image={
      <SkeletonImageWrap>
        <Skeleton width="79px" height="78px" />
      </SkeletonImageWrap>
    }
  >
    <Skeleton width="85px" />
    <Skeleton />
    <Skeleton width="60px" />
  </CardWrapper>
);
